import { useEffect, useRef } from 'react'
import { useQueryClient, type QueryKey } from '@tanstack/react-query'

import { useAuth } from '@/lib/auth'
import { subscribeToBrowserEvent } from '@/lib/signalr/connection-manager'

import { browserEventKey, type BrowserEvent } from './browser-event'

export function useRefreshQueriesOn(
  event: BrowserEvent<unknown[]>,
  queryKeys: readonly QueryKey[],
): void {
  const { isAuthenticated } = useAuth()
  const queryClient = useQueryClient()
  const eventRef = useRef(event)
  const queryKeysRef = useRef(queryKeys)
  useEffect(() => {
    eventRef.current = event
    queryKeysRef.current = queryKeys
  })

  const key = browserEventKey(event)
  useEffect(() => {
    if (!isAuthenticated) return
    const refresh = () => {
      for (const queryKey of queryKeysRef.current)
        void queryClient.invalidateQueries({ queryKey })
    }
    return subscribeToBrowserEvent(eventRef.current, () => refresh(), refresh)
  }, [isAuthenticated, key, queryClient])
}
